import unavailableProducts from '../helpers/unavailableProducts';

describe('checkProductName', () => {
  it('should return true if product name contains unavailable products', () => {
    const productName1 = 'TAB - Bank Statement Conventional - 2-year';
    const result1 = unavailableProducts(productName1);
    const productName2 = 'TAB - Paycheck Protection Second Draw';
    const result2 = unavailableProducts(productName2);
    const productName3 = 'Sunflower Marketplace - Conventional 3-year';
    const result3 = unavailableProducts(productName3);

    expect(result1).toBe(true);
    expect(result2).toBe(true);
    expect(result3).toBe(true);
  });

  it('should return false if product name does not contain unavailable products', () => {
    const productName1 = 'TAB - Conventional - 2-year';
    const result1 = unavailableProducts(productName1);
    const productName2 = 'Celtic - SBA';
    const result2 = unavailableProducts(productName2);

    expect(result1).toBe(false);
    expect(result2).toBe(false);
  });

  it('should return empty string for non-string input', () => {
    const nonStringInput = undefined;
    const result = unavailableProducts(nonStringInput);

    expect(result).toBe(false);
  });
});
